var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 19,
    fill: "#00D46D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5583 26.7333C15.8999 26.7333 15.2749 26.575 14.7249 26.2583C13.4249 25.5083 12.7083 23.9833 12.7083 21.975V16.0333C12.7083 14.0166 13.4249 12.5 14.7249 11.75C16.0249 11 17.6999 11.1416 19.4499 12.15L24.5916 15.1166C26.3333 16.125 27.2999 17.5083 27.2999 19.0083C27.2999 20.5083 26.3416 21.8916 24.5916 22.9L19.4499 25.8666C18.4416 26.4416 17.4583 26.7333 16.5583 26.7333ZM16.5583 12.5166C16.1083 12.5166 15.7083 12.6166 15.3499 12.825C14.4499 13.3416 13.9583 14.4833 13.9583 16.0333V21.9666C13.9583 23.5166 14.4499 24.65 15.3499 25.175C16.2499 25.7 17.4833 25.55 18.8249 24.775L23.9666 21.8083C25.3083 21.0333 26.0499 20.0416 26.0499 19C26.0499 17.9583 25.3083 16.9666 23.9666 16.1916L18.8249 13.225C18.0083 12.7583 17.2416 12.5166 16.5583 12.5166Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVideoIcon);
export default __webpack_public_path__ + "static/media/newVideoIcon.4ff77d81e4129f18435e7b98cd69152e.svg";
export { ForwardRef as ReactComponent };